import React from "react";
import { Link as RRDLink, type LinkProps } from "react-router-dom";

import { useUser } from "#/contexts/UserContext";

export function Link({
  to,
  external = false,
  children,
  ...props
}: LinkProps & { external?: boolean }) {
  return (
    <RRDLink
      to={to}
      unstable_viewTransition
      {...{
        ...props,
        ...(external
          ? {
              target: "_blank",
              rel: "noopener noreferrer",
            }
          : {}),
      }}
    >
      {children}
    </RRDLink>
  );
}

export function OrganizationScopedLink({
  to,
  children,
  ...props
}: LinkProps & { to: string }) {
  const { user } = useUser();
  if (!user) return <></>;

  return (
    <Link to={to.replace(":organization_id", user.organization.id)} {...props}>
      {children}
    </Link>
  );
}
